module.exports = __webpack_public_path__ + "img/fushineiyi.37537424.png";